.gas-rental-cart {
    max-width: 980px;
    margin: 0 auto;
    font-size: var(--gas-text-m, 16px);
    line-height: 1.55;
}
.gas-rental-cart h1 { margin: 0 0 var(--gas-space-m, 10px); }

.gas-rental-cart__layout {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: var(--gas-space-l, 20px);
    align-items: start;
}
@media (max-width: 760px) {
    .gas-rental-cart__layout { grid-template-columns: 1fr; }
}

.gas-rental-cart__lines ul { list-style: none; margin: 0; padding: 0; }

.gas-rental-cart__lines h2,
.gas-rental-cart__when h2 { margin: 0 0 var(--gas-space-m, 16px); font-size: var(--gas-text-l, 20px); }

.gas-rental-cart__line {
    display: flex;
    gap: var(--gas-space-m, 16px);
    padding: var(--gas-space-m, 16px) 0;
    align-items: flex-start;
    border-bottom: 1px solid var(--gas-border-subtle, #eef2f4);
}
.gas-rental-cart__line:first-child { padding-top: 0; }
.gas-rental-cart__thumb {
    width: 88px;
    height: 88px;
    object-fit: contain;
    border-radius: var(--gas-radius-s, 8px);
    border: 1px solid var(--gas-border-default, #e1e8ed);
    flex: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    background: var(--gas-color-surface-muted, #f1f6f7);
}
.gas-rental-cart__line-main { flex: 1; display: flex; flex-direction: column; gap: var(--gas-space-xs, 6px); min-width: 0; }
.gas-rental-cart__line-main > strong,
.gas-rental-cart__line-name { font-size: var(--gas-text-m, 16px); font-weight: 600; line-height: 1.35; }
.gas-rental-cart__line-qty { display: flex; align-items: center; gap: var(--gas-space-m, 14px); flex-wrap: wrap; }
.gas-rental-cart__qty-label { display: inline-flex; align-items: center; gap: var(--gas-space-xs, 6px); }
.gas-rental-cart__qty {
    padding: 5px 10px;
    border: 1px solid var(--gas-border-default, #e1e8ed);
    border-radius: var(--gas-radius-s, 8px);
    background: var(--gas-color-surface-default, #fff);
    color: inherit;
    font: inherit;
}
.gas-rental-cart__qty-fixed { font-weight: 600; }
.gas-rental-cart__remove,
.gas-rental-cart__waitlist,
.gas-rental-cart__clear {
    background: none;
    border: none;
    color: var(--gas-color-primary, #004253);
    cursor: pointer;
    text-decoration: underline;
    padding: 0;
    font: inherit;
}
.gas-rental-cart__remove { color: var(--gas-color-danger, #c0392b); }
.gas-rental-cart__waitlist { margin-left: var(--gas-space-s, 6px); }
.gas-rental-cart__clear { margin-top: var(--gas-space-s, 7.5px); }

.gas-rental-cart__avail { font-size: var(--gas-text-s, 8.5px); }
.gas-rental-cart__avail--ok { color: var(--gas-color-success, #2e7d4f); font-weight: 600; }
.gas-rental-cart__avail--ko { color: var(--gas-color-danger, #c0392b); }

.gas-rental-cart__when {
    background: var(--gas-color-surface-raised, #fff);
    border: 1px solid var(--gas-border-subtle, #eef2f4);
    border-radius: var(--gas-radius-l, 16px);
    padding: var(--gas-space-l, 20px);
}
.gas-rental-cart__range {
    display: flex;
    gap: var(--gas-space-l, 20px);
    margin: var(--gas-space-m, 14px) 0;
    flex-wrap: wrap;
}
.gas-rental-cart__range > div {
    padding: var(--gas-space-s, 10px) var(--gas-space-m, 14px);
    border: 1px solid var(--gas-border-subtle, #eef2f4);
    border-radius: var(--gas-radius-s, 8px);
    min-width: 140px;
}
.gas-rental-cart__date-hint {
    margin: var(--gas-space-s, 10px) 0 0;
    padding: var(--gas-space-s, 10px) var(--gas-space-m, 14px);
    font-size: var(--gas-text-s, 13px);
    color: var(--gas-color-primary, #004253);
    background: var(--gas-color-surface-muted, #f1f6f7);
    border-radius: var(--gas-radius-s, 8px);
}
.gas-rental-cart__range > div { display: flex; flex-direction: column; gap: 2px; }
.gas-rental-cart__range-label { font-size: var(--gas-text-s, 8px); color: var(--gas-text-muted, #6b7d85); }
.gas-rental-cart__hint,
.gas-rental-cart__note { font-size: var(--gas-text-s, 8.5px); color: var(--gas-text-muted, #6b7d85); }
.gas-rental-cart__total { font-size: var(--gas-text-m, 10.5px); }
.gas-rental-cart__submit { margin-top: var(--gas-space-s, 7.5px); }
.gas-rental-cart__success { color: var(--gas-color-success, #2e7d4f); font-weight: 600; }

.gas-rental-cart__cal-caption {
    font-size: var(--gas-text-s, 8.2px);
    color: var(--gas-text-muted, #6b7d85);
    margin: 0 0 var(--gas-space-xs, 5px);
}
.gas-rental-cart__line.is-focused {
    background: var(--gas-color-surface-muted, #f1f6f7);
    border-radius: var(--gas-radius-s, 8px);
}

/* Ligne à période propre (location en 2 temps) */
.gas-rental-cart__line--dated {
    border-left: 3px solid var(--gas-color-primary, #2563eb);
}

.gas-rental-cart__line-dates {
    display: block;
    font-size: var(--gas-font-size-s, 14px);
    color: var(--gas-color-intent-muted, #555);
    margin: 2px 0 4px;
}

.gas-rental-cart__line-dates-clear {
    background: none;
    border: none;
    padding: 0;
    margin-left: var(--gas-space-2, 8px);
    color: var(--gas-color-primary, #2563eb);
    text-decoration: underline;
    cursor: pointer;
    font-size: inherit;
}

/* Récapitulatif des segments (N réservations en une caisse) */
.gas-rental-cart__segments {
    margin: var(--gas-space-3, 12px) 0;
    padding: var(--gas-space-3, 12px);
    border: 1px solid var(--gas-color-border, #ddd);
    border-radius: var(--gas-radius-m, 8px);
    background: var(--gas-color-surface-alt, #fafafa);
}

.gas-rental-cart__segments-title {
    margin: 0 0 var(--gas-space-2, 8px);
    font-weight: 600;
}

.gas-rental-cart__segments ul {
    margin: 0;
    padding-left: var(--gas-space-4, 16px);
}
